export default __webpack_public_path__ + "static/media/drag360White.028e5e43.png";